"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downDocReleaseOrder = downDocReleaseOrder;
exports.downloadEdoXm = downloadEdoXm;
exports.exportEdoSK = exportEdoSK;
exports.exportNew = exportNew;
exports.exportNewQD = exportNewQD;
exports.exportNewQDs = exportNewQDs;
exports.searchHistory = searchHistory;
var _request = _interopRequireDefault(require("@/utils/request"));
// 换单预约历史-查询
function searchHistory(data) {
  return (0, _request.default)({
    url: "/ebusiness/edoCredit/searchHistory",
    method: 'post',
    data: data
  });
}

//换单预约历史-打印厦门
function downloadEdoXm(bookingHeadId) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/edoCredit/downloadEdoXm/".concat(bookingHeadId),
    method: 'post'
  });
}

//换单预约青岛-单条打印
function exportNewQD(edoCreditId) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/edoCredit/exportNewQD/".concat(edoCreditId),
    method: 'post'
  });
}
//换单预约青岛-批量打印
function exportNewQDs(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/edoCredit/exportNewQDs",
    method: 'post',
    data: data
  });
}

//换单预约历史-新港、宁波打印
function exportNew(edoCreditId) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/edoCredit/exportNew/".concat(edoCreditId),
    method: 'post'
  });
}

//换单预约历史-下载PH
function downDocReleaseOrder(bookingHeadId, eta, blNo, portCode) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/edoCredit/downDocReleaseOrder?bookingHeadId=" + bookingHeadId + "&eta=" + eta + "&blNo=" + blNo + "&portCode=" + portCode,
    method: 'post'
  });
}
//换单预约历史-蛇口
function exportEdoSK(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/edoCredit/exportEdoSK",
    method: 'post',
    data: data
  });
}